// Premium step container card used by all calculator steps
import { Card } from "@/components/ui/card";

/**
 * @param {object} props
 * @param {number} props.stepNumber  current step number (1-based)
 * @param {number} props.totalSteps  total steps in this mode
 * @param {string} props.label       Short step label e.g. "Your Home & Hot Water Habits"
 * @param {boolean} [props.staffMode]
 * @param {React.ReactNode} props.children
 */
export default function CalcStepCard({ stepNumber, totalSteps, label, staffMode, children }) {
  const pct = Math.round((stepNumber / totalSteps) * 100);
  return (
    <Card data-testid="calc-step-card" className="rounded-3xl p-6 sm:p-10 border-[#E2E8F0] bg-white shadow-[0_20px_60px_-30px_rgba(11,19,43,0.18)]">
      <div className="flex items-start sm:items-center justify-between gap-4 flex-col sm:flex-row mb-5">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#475569] flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-[#0B132B] text-white text-[10px]">
              Step {stepNumber} of {totalSteps}
            </span>
            <span className="text-[#0B132B] hidden sm:inline">·</span>
            <span className="text-[#0B132B]">{label}</span>
          </p>
          {staffMode && (
            <span
              data-testid="calc-staff-badge"
              className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-[10px] font-semibold tracking-widest uppercase"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500" /> Staff Mode · Internal Use
            </span>
          )}
        </div>
        <span className="text-xs font-semibold text-[#10B981] num-tab">{pct}%</span>
      </div>

      {/* Step dot indicator */}
      <div className="mb-7">
        <div className="flex items-center gap-1.5">
          {Array.from({ length: totalSteps }).map((_, i) => (
            <span
              key={i}
              className={`h-1.5 flex-1 rounded-full transition-all ${
                i < stepNumber ? "bg-[#10B981]" : "bg-[#E2E8F0]"
              }`}
            />
          ))}
        </div>
      </div>

      {children}
    </Card>
  );
}
